import React from 'react';

const Tooltip = ({ text, children }) => (
  <div className="group/tip relative">
    {children}
    <span className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-[11px] font-medium text-white opacity-0 group-hover/tip:opacity-100 group-hover/tip:delay-150 transition-opacity duration-150 z-50 after:content-[''] after:absolute after:top-full after:left-1/2 after:-translate-x-1/2 after:border-4 after:border-transparent after:border-t-gray-900">
      {text}
    </span>
  </div>
);

export default Tooltip;
